import { Star, Quote } from 'lucide-react';
import { Reveal, SectionHeading } from './Reveal';
import { TESTIMONIALS } from '../data/content';

const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="mx-auto max-w-7xl scroll-mt-24 px-6 py-28 lg:px-10 lg:py-36">
    <SectionHeading eyebrow="Client Words" title={<>Trusted by those<br /><span className="italic text-gold">who expect more.</span></>} />
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {TESTIMONIALS.map((t, i) => (
        <Reveal key={t.name} delay={(i % 3) * 0.1} className="h-full">
          <figure
            data-testid={`testimonial-card-${i}`}
            className="flex h-full flex-col border border-white/5 bg-surface p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/25"
          >
            <Quote className="h-6 w-6 text-gold/40" strokeWidth={1} />
            <blockquote className="mt-5 flex-1 text-base font-light leading-relaxed text-white/75">“{t.quote}”</blockquote>
            <figcaption className="mt-7 border-t border-white/10 pt-5">
              <div className="flex gap-1" aria-label="5 star rating">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-3.5 w-3.5 fill-gold text-gold" />
                ))}
              </div>
              <div className="mt-3 text-sm font-medium text-white">{t.name}</div>
              <div className="text-xs uppercase tracking-[0.2em] text-gold/70">{t.detail}</div>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Testimonials;
